import { Home, FileText, Users, MessageSquare, MessageCircle, User, CreditCard, BarChart3, Settings, Send, LogOut, Shield, LayoutDashboard, Zap, Layers, Smartphone, Package, QrCode, Headphones, GitBranch, Sparkles } from "lucide-react";

import { whatsappChildren } from "./whatsappRoutes";

export const routeData = [
    {
        id: 1,
        name: 'Dashboard',
        url: '/home/dashboard',
        componentName: 'Dashboard',
        navName: 'Home',
        icon: <Home />,
        requiredEntitlement: 'CRM',
    },
    {
        id: 2,
        name: 'Customers',
        navName: 'Customers',
        url: '/customers/index',
        componentName: 'CustomersIndex',
        icon: <Users />,
        requiredEntitlement: 'CRM'
    },
    {
        id: 3,
        name: 'ProductRegistration',
        navName: 'Products',
        url: '/product/index',
        componentName: 'ProductIndex',
        icon: <Package />,
        requiredEntitlement: 'CRM'
    },
    {
        id: 4,
        name: 'Complaints',
        url: '/complaint/index',
        componentName: 'ComplaintIndex',
        navName: 'Complaints',
        icon: <FileText />,
        requiredEntitlement: 'CRM',
    },
    {
        id: 5,
        name: 'SelfService',
        url: '/selfservice',
        componentName: 'SelfServiceIndex',
        navName: 'Self Service',
        icon: <Headphones />,
        requiredEntitlement: 'CRM',
        children: [
            {
                id: 51,
                name: 'Model Management',
                url: '/selfservice/models',
                componentName: 'ModelManagement',
                icon: <Package />,
            },
            {
                id: 52,
                name: 'QR Code Generation',
                url: '/selfservice/qr',
                componentName: 'QRCodeGeneration',
                icon: <QrCode />,
            }
        ]
    },
    {
        id: 7,
        name: 'Setting',
        url: '/setting/index',
        componentName: 'SettingIndex',
        navName: 'Settings',
        icon: <Settings />,
    },
    {
        id: 8,
        name: 'Logout',
        navName: 'Logout',
        icon: <LogOut />
    },
    {
        id: 11,
        name: 'ComplaintAdd',
        url: '/complaint/*',
        componentName: 'ComplaintAdd',
        requiredEntitlement: 'CRM'
    },
    {
        id: 12,
        name: 'ProductAdd',
        url: '/product/*',
        componentName: 'ProductAdd',
        requiredEntitlement: 'CRM'
    },
    {
        id: 13,
        name: 'Permissions',
        navName: 'Permissions',
        url: '/permissions/index',
        componentName: 'PermissionsIndex',
        icon: <Shield />,
        requiredEntitlement: 'CRM'
    },
    {
        id: 14,
        name: 'Whatsapp',
        navName: 'WhatsApp',
        url: '/whatsapp/index',
        icon: <MessageSquare />,
        requiredEntitlement: 'WHATSAPP',
        children: whatsappChildren
    },
    {
        id: 141,
        name: 'CreateTemplate',
        url: '/whatsapp/templates/create',
        componentName: 'CreateTemplatePage',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 142,
        name: 'ManageTemplates',
        url: '/whatsapp/templates/manage',
        componentName: 'ManageTemplatesPage',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 152,
        name: 'CreateWorkflow',
        url: '/whatsapp/workflows/create',
        componentName: 'CreateWorkFlow',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 153,
        name: 'WorkFlowBuilder',
        url: '/whatsapp/workflows/create/new',
        componentName: 'WorkFlowBuilder',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 154,
        name: 'WorkFlowBuilderEdit',
        url: '/whatsapp/workflows/:id/edit',
        componentName: 'WorkFlowBuilder',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 155,
        name: 'WorkflowSettings',
        url: '/whatsapp/workflows/settings',
        componentName: 'WorkflowSettings',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 156,
        name: 'WorkflowAnalytics',
        url: '/whatsapp/workflows/analytics',
        componentName: 'WorkflowAnalytics',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 157,
        name: 'BasicAutomations',
        url: '/whatsapp/workflows/basic-automations',
        componentName: 'BasicAutomations',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 1431,
        name: 'NewCampaign',
        url: '/whatsapp/campaigns/new',
        componentName: 'NewCampaign',
        requiredEntitlement: 'WHATSAPP',
    },
    {
        id: 1432,
        name: 'CampaignAnalytics',
        url: '/whatsapp/campaigns/:id',
        componentName: 'CampaignAnalytics',
        requiredEntitlement: 'WHATSAPP',
    }
]

export const lowerNavBarList = ['Profile', 'Setting', 'Logout'];
